import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CmsLink, CmsLinkLocation, CmsLinkTarget } from '@/models';
import { HeaderLinkWebInteractions } from '@/services/analytics/platforms/adobe-analytics/constants';
import { HeaderFlags } from '@/store/ui';

@Component({
  name: 'CmgHeaderHamburgerIcon',
})
export default class CmgHeaderHamburgerIcon extends Vue {
    get hamburgerMenuImageUrl(): string {
        return this.$appStore.state.cms.images.icons.menuHamburger.default;
    }

    get headerOptions() {
        return this.$appStore.state.ui.header.options;
    }

    get headerFlags() {
        return this.headerOptions.flags;
      }
    
    get allHeaderFlags() {
        return HeaderFlags;
    }

    get returnToRouteNavItem(): CmsLink {
        const navItem: CmsLink = {
          type: 'text',
          location: CmsLinkLocation.Internal,
          text: this.headerOptions.routeText || '',
          url: this.headerOptions.route || '',
          target: CmsLinkTarget.Self,
        };
        
        return navItem;
    }

    showAccountMenu(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('account', true);
        Vue.nextTick(() => this.$services.ui.focusDiv('.modal-content'));
    
        this.$services.analytics.addLinkClickedEventToStore(HeaderLinkWebInteractions.Hey);
    }
}
